<template>
    <div class="sustainable-component admin-workspace-all">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-workspace-all</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row mb-3">
                <div class="col-12 p-0">
                    <CommonLabelContainer title="Skapa arbetsplats" class="mt-5 mb-3">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <v-select name="Department"
                                                  :rules="[rules.required]"
                                                  v-model="selectedDepartment"
                                                  id="department"
                                                  item-title="DepartmentName"
                                                  item-value="DepartmentId"
                                                  :items="departments"
                                                  label="Avdelning">
                                        </v-select>
                                        <v-select name="Club"
                                                  :rules="[rules.required]"
                                                  v-model="selectedClub"
                                                  item-title="ClubName"
                                                  item-value="ClubId"
                                                  :items="clubs"
                                                  label="Klubb">
                                        </v-select>
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="WorkspaceName"
                                                      id="WorkspaceName"
                                                      type="text"
                                                      label="Arbetsplatsnamn"
                                                      variant="outlined"
                                                      v-model="workspace.WorkspaceName"></v-text-field>
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="Adress"
                                                      id="Adress"
                                                      type="text"
                                                      label="Adress"
                                                      variant="outlined"
                                                      v-model="workspace.Address"></v-text-field>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="ZipCode"
                                                      id="ZipCode"
                                                      type="text"
                                                      label="Postnummer"
                                                      variant="outlined"
                                                      v-model="workspace.ZipCode"></v-text-field>
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="City"
                                                      id="City"
                                                      type="text"
                                                      label="Ort"
                                                      variant="outlined"
                                                      v-model="workspace.City"></v-text-field>
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="Telephone"
                                                      id="Telephone"
                                                      type="text"
                                                      label="Telefon"
                                                      variant="outlined"
                                                      v-model="workspace.Telephone"></v-text-field>
                                        <div class="company-create-actions">
                                            <v-btn variant="tonal" @click="createWorkspace" class="bg-primary">
                                                Skapa
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row table-space">
                <b>Visar {{filteredWorkspaces.length}} av {{workspaces.length}} arbetsplatser</b>
                <div class="mt-3">
                    <v-text-field bg-color="white"
                                  name="FilterWorkspace"
                                  id="FilterWorkspace"
                                  type="text"
                                  label="Filtrera på arbetsplats, klubb, adress, postnummer, ort eller telefon"
                                  variant="outlined"
                                  v-model="filter"
                                  focused="true"></v-text-field>
                </div>
                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-2">Arbetsplats</th>
                            <th class="col-2">Klubb</th>
                            <th class="col-2">Adress</th>
                            <th class="col-2">Postnr</th>
                            <th class="col-2">Ort</th>
                            <th class="col-2">Telefon</th>
                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in filteredWorkspaces" :key="index">
                            <td>{{item.WorkspaceName}}</td>
                            <td>{{item.ClubDepartment}}</td>
                            <td>{{item.Address}}</td>
                            <td>{{item.ZipCode}}</td>
                            <td>{{item.City}}</td>
                            <td>{{item.Telephone}}</td>
                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateWorkspace(item)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="deleteWorkspace(item.WorkspaceId)">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <UpdateWorkspace ref="updateWorkspaceModal" @updated="loadWorkspaces"></UpdateWorkspace>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import UpdateWorkspace from './update/update-workspace.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const form = ref(null);
    const updateWorkspaceModal = ref(null);

    export default {

        name: 'admin-workspace-all',
        props: {
            departmentid: String,
        },
        components: {
            UpdateWorkspace,
            CommonLabelContainer,
            CommonSpinner
        },
        methods: {
            async createWorkspace() {
                var result = await this.form.validate()
                if (result.valid != true)
                    return;
                this.loading++;
                this.workspace.DepartmentId = this.selectedDepartment;
                this.workspace.ClubId = this.selectedClub;
                try {
                    await AdminService.createWorkspace(this.workspace);
                    this.displaySnackBar("Arbetsplatsen lades till");
                    this.loadWorkspaces();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async loadWorkspaces() {
                this.loading++;
                try {
                    if (this.selectedClub != null) {
                        this.workspaces = await AdminService.getWorkspacesFromClub(this.selectedClub);
                    }
                    else if (this.selectedDepartment != null) {
                        this.workspaces = await AdminService.getWorkspaceFromDepartment(this.selectedDepartment);
                    }
                    else {
                        this.workspaces = await AdminService.getAllWorkspaces();
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            
            async updateWorkspace(workspace) {
                this.loading++;
                this.updateWorkspaceModal.open(workspace)
                this.loading--;
            },
            async deleteWorkspace(workspaceId) {
                if (confirm("Är du säker att du vill radera arbetsplatsen?")) {
                    this.loading++;
                    try {
                        await AdminService.deleteWorkspace(workspaceId);
                        this.displaySnackBar("Arbetsplatsen togs bort");
                        this.loadWorkspaces();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Det gick inte att radera arbetsplatsen, kontrollera så att det inte finns ett företag under denna arbetsplats, i sånt fall måste denna raderas först.")
                    }
                    this.loading--;
                }
            },
            async loadDepartments() {
                this.loading++;
                try {
                    var departments = [{ DepartmentName: 'Ingen vald', DepartmentId: null }, ...await AdminService.getDepartments()];
                    this.departments = departments;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadClubs(departmentId) {
                this.loading++;
                try {
                    var clubs = [{ ClubName: 'Ingen vald', ClubId: null }, ...await AdminService.getClubsFromDepartment(departmentId)];
                    this.clubs = clubs
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
            matchesFilter(workspace) {
                const filter = (this.filter || "").trim().toLowerCase();
                if (filter.length === 0) {
                    return true;
                }

                const searchableText = [
                    workspace.WorkspaceName,
                    workspace.ClubDepartment,
                    workspace.Address,
                    workspace.ZipCode,
                    workspace.City,
                    workspace.Telephone
                ].join(" ").toLowerCase();

                return filter
                    .split(/\s+/)
                    .every(term => searchableText.indexOf(term) >= 0);
            },
        },

        computed: {
            filteredWorkspaces() {
                return this.workspaces.filter(this.matchesFilter);
            }
        },

        data() {
            return {
                rules: ValidationService.rules(),
                workspace: {
                    WorkspaceName: '',
                    DepartmentId: 0,
                    ClubId: 0,
                    Address: '',
                    ZipCode: '',
                    City: '',
                    Telephone: ''
                },
                workspaces: [],
                filter: '',
                selectedDepartment: null,
                selectedClub: null,
                clubs: [],
                departments: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedDepartment: function (newVal) {
                this.selectedClub = null;
                if (newVal != null)
                    this.loadClubs(newVal);
                this.loadWorkspaces()
            },
            selectedClub: function () {
                this.loadWorkspaces()
            },
        },
        mounted() {
            this.filter = new URLSearchParams(window.location.search).get('filter') || '';
            this.selectedDepartment = this.departmentid;
            //this.loadWorkspaces();
            this.loadDepartments();
            //if (this.departmentid != null)
            //    this.loadClubs(this.departmentid);
        },
        setup() {
            return { form, updateWorkspaceModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>